import useLogout from "app/core/hooks/useLogout"
import { useRouter } from "next/router"
import { FC, PropsWithChildren, useState } from "react"

export const LogoutButton: FC<PropsWithChildren<{}>> = ({ ...props }) => {
  const [running, setRunning] = useState(false)
  const logout = useLogout()

  const router = useRouter()

  return (
    <button
      className={`text-alert-primary text-semibold text-left flex gap-2`}
      style={{
        outline: "none",
      }}
      {...props}
      onClick={async () => {
        setRunning(true)
        await logout()

        router.push("/api/auth/logout")
      }}
    >
      <span className="">Log Out</span>
    </button>
  )
}
